/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_z1 as z1,
} from "../../runtime/index.jsx";
export function RespuestaActa(e) {
  let t = (0, ReactCompiler.c)(6),
    { item: n, valor: r, completa: i } = e,
    a = i !== void 0 && i,
    o;
  t[0] === r
    ? (o = t[1])
    : ((o = Array.isArray(r) ? r.join(`, `) : r), (t[0] = r), (t[1] = o));
  let s = o;
  if (s == null || s === ``) {
    let e;
    return (
      t[2] === Symbol.for(`react.memo_cache_sentinel`)
        ? ((e = (
            <span
              className={`shrink-0 rounded-full border border-(--border) px-2 py-0.5 text-[11px] text-(--text)`}
              children={`Sin responder`}
            />
          )),
          (t[2] = e))
        : (e = t[2]),
      e
    );
  }
  let c = z1(n, r)
      ? `border-(--error) bg-(--error-bg) text-(--error)`
      : s === `N.A.`
        ? `border-(--border) text-(--text)`
        : `border-(--success) text-(--success)`,
    l = `${a ? `max-w-full` : `max-w-[55%] shrink-0 truncate`} rounded-full border px-2 py-0.5 text-[11px] font-semibold ${c}`,
    u;
  return (
    t[3] !== l || t[4] !== s
      ? ((u = <span className={l} children={s} />),
        (t[3] = l),
        (t[4] = s),
        (t[5] = u))
      : (u = t[5]),
    u
  );
}
